<div class="salas-de-aula flex flex-col mt-15" [class.estilo-projecao]="estiloProjecao">
  <div class="flex justify-between items-center mb-6">
    <h1 class="text-heading-lg m-0"
        [ngClass]="estiloProjecao ? 'text-blue-600 font-bold' : 'titulo-cinza text-semibold'">
      Salas de aula: diagnóstico e projeção
    </h1>
    <button *ngIf="pdfClick.observed" mat-raised-button color="primary" class="botao-pdf"
            [disabled]="carregandoPdf" (click)="pdfClick.emit()">
      <mat-icon>download</mat-icon>
      {{ carregandoPdf ? 'Gerando PDF...' : 'Baixar PDF' }}
    </button>
  </div>

  <div class="tabela-wrapper rounded-sm sm-shadow">
    <table class="tabela-salas">
      <thead>
        <tr>
          <th class="text-start">Etapa/modalidade</th>
          <th class="text-start">Área de localidade</th>
          <th class="text-center">Número de salas de aula existentes<sup>(1)</sup></th>
          <th class="text-end">Salas de aula necessárias<sup>(2)</sup></th>
          <th class="text-end">Demanda por novas salas de aula<sup>(3)</sup></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let linha of linhas; let primeira = first">
          <td *ngIf="linha.etapa" rowspan="2" class="text-start celula-mesclada">
            <span *ngFor="let nome of linha.etapa" class="nome-etapa">{{ nome }}</span>
          </td>
          <td class="text-start">{{ linha.area }}</td>
          <td *ngIf="primeira" rowspan="4" class="text-center celula-mesclada">
            {{ (salasExistentes?.resultadoNumSalasExistentesTotal ?? 0) | number:'1.0-0':'pt' }}
          </td>
          <td class="text-end">{{ linha.necessarias | number:'1.0-0':'pt' }}</td>
          <td class="text-end">{{ linha.demanda | number:'1.0-0':'pt' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="notas">
    <p>Notas:</p>
    <p><sup>(1)</sup> Número de salas existentes calculado a partir do Censo Escolar.</p>
    <p>
      <sup>(2)</sup> A estimativa do número de salas necessárias é feita com base no número de turmas por turno
      (parcial e integral) e a etapa de atendimento (separando EI das demais etapas). A cada duas turmas parciais
      diurnas se estima uma sala; a cada turma integral se estima uma sala. O noturno é contabilizado como parcial,
      mas é considerado apenas para o cálculo de salas necessárias quando o seu valor é maior que a soma de salas do
      diurno e integral.
    </p>
    <p>
      <sup>(3)</sup> A demanda é calculada com base na diferença entre o número de salas existentes e o número de salas
      necessárias calculado pelo simulador em cada escola; portanto, a demanda não se refere à diferença entre o
      existente e o necessário.
    </p>
  </div>
</div>
